<template>
  <div>
    <!-- <div class="ad_footer">
		  <div class="ad_let" v-if="imgLeft">
		    <el-collapse class="hidden-sm-and-down Ad_Notice" v-model="activeNamesLeft">
    <el-collapse-item name="1">-->
    <!-- <template slot="title">
		          <div class="Ad_title">编辑部通知左</div>
    </template>-->
    <!-- <div class="ad_content">
					<img :src="imgLeft" alt="" srcset="">
    </div>-->
    <!-- </el-collapse-item>
		    </el-collapse>
    </div>-->
    <!-- <div class="ad_right" v-if="imgRight">
		    <el-collapse accordion class="hidden-sm-and-down Ad_Notice" v-model="activeNamesRight">
    <el-collapse-item name="1">-->
    <!-- <template slot="title">
		          <div class="Ad_title">编辑部通知右</div>
    </template>-->
    <!-- <div class="ad_content">
					<img :src="imgRight" alt="" srcset="">
    </div>-->
    <!-- </el-collapse-item>
		    </el-collapse>
		  </div>
    </div>-->
    <div class="ad_sidebar">
      <div class="ad_let" v-show="adShowLeft">
        <a :href="urlLeft">
          <img :src="imgLeft" width="124" height="264" />
        </a>
        <a class="ad_close" @click.prevent="closeAdLeft">
          <i class="el-icon-close"></i>
        </a>
      </div>
      <div class="ad_right" v-show="adShowRight">
        <a :href="urlRight">
          <img :src="imgRight" width="120" height="300" />
        </a>
        <a class="ad_close" @click.prevent="closeAdRight">
          <i class="el-icon-close"></i>
        </a>
      </div>
       <div id="thediv" ref="thediv" v-show="adShowFd">
         <a :href="urlFd">
            <img :src="imgFd" width="120" height="120">
         </a>
         <a class="ad_Fd" @click.prevent="closeAdFd">
          <i class="el-icon-close"></i>
        </a>
       </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeNamesLeft: ["1"],
      activeNamesRight: ["1"],
      adShowLeft: false,
      adShowRight: false,
      adShowFd:false,
      imgLeft: "",
      imgRight: "",
      imgFd:"",
      urlLeft: "",
      urlRight: "",
      urlFd:"",
      xPos:300,
       yPos:200,
       step:1,
       delay:8,
       height:0,
       Hoffset:0,
       Woffset:0,
       yon:0,
       xon:0,
       pause:true,
    };
  },
  mounted() {
    var interval=setInterval(this.changePos,50)
    this.$store
      .dispatch("_GetFloatingAds")
      .then(res => {
        if (res.data.Data) {
          let data = res.data.Data;
          data.forEach(item => {
            switch (item.AdType) {
              case (item.AdType = 1):
                if (sessionStorage.getItem("adShowFd") == 1) {
                  this.adShowFd = false;
                } else {
                  this.adShowFd = true;
                  this.imgFd =
                    this.ImgUrl + item.PictureGUID + item.PictureSuffix;
                    console.log(this.imgFd,33)
                  this.urlFd = item.Url;
                }

                break;
              case (item.AdType = 2):
                if (sessionStorage.getItem("adShowLeft") == 1) {
                  this.adShowLeft = false;
                } else {
                  this.adShowLeft = true;
                  this.imgLeft =
                    this.ImgUrl + item.PictureGUID + item.PictureSuffix;
                  this.urlLeft = item.Url;
                }

                break;
              case (item.AdType = 3):
                if (sessionStorage.getItem("adShowRight") == 1) {
                  this.adShowRight = false;
                } else {
                  this.adShowRight = true;
                  this.imgRight =
                    this.ImgUrl + item.PictureGUID + item.PictureSuffix;
                  this.urlRight = item.Url;
                }

                break;
              default:
                this.adShowLeft = false;
                this.adShowRight = false;
                break;
            }
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    closeAdLeft() {
      this.adShowLeft = false;
      sessionStorage.setItem("adShowLeft", "1");
    },
    closeAdRight() {
      this.adShowRight = false;
      sessionStorage.setItem("adShowRight", "1");
    },
    closeAdFd(){
      this.adShowFd = false;
      sessionStorage.setItem("adShowFd", "1");
    },
    changePos()
      {
          let width=document.documentElement.clientWidth;
          let height=document.documentElement.clientHeight;
          this.Hoffset=this.$refs.thediv.offsetHeight;
          this.Woffset=this.$refs.thediv.offsetWidth;
          this.$refs.thediv.style.left=(this.xPos+document.body.scrollLeft+document.documentElement.scrollLeft)+"px";
          this.$refs.thediv.style.top=(this.yPos+document.body.scrollTop+document.documentElement.scrollTop)+"px";
          if(this.yon)
          {
              this.yPos=this.yPos+this.step;
          }
          else
          {
              this.yPos=this.yPos-this.step;
          }
          if(this.yPos<0)
          {
              this.yon=1;
              this.yPos=0;
          }
          if(this.yPos>=(height-this.Hoffset))
          {
              this.yon=0;
              this.yPos=(height - this.Hoffset);
          }
          if(this.xon)
          {
              this.xPos=this.xPos + this.step;
          }
          else
          {
              this.xPos=this.xPos - this.step;
          }
          if(this.xPos < 0)
          {
              this.xon = 1;
              this.xPos = 0;
          }
          if(this.xPos >= (width - this.Woffset))
          {
              this.xon = 0;
              this.xPos = (width - this.Woffset);
          }
      },
  }
};
</script>
<style>
.Ad_Notice {
  width: 250px;
  -webkit-box-shadow: rgba(62, 57, 107, 0.3) 0px 6px 16px 0px;
  -moz-box-shadow: rgba(62, 57, 107, 0.3) 0px 6px 16px 0px;
  box-shadow: rgba(62, 57, 107, 0.3) 0px 6px 16px 0px;
}
.Ad_title {
  font-size: 15px;
  padding-left: 15px;
}
.el-collapse-item__header {
  background: #c5dbf0;
  color: #124f83 !important;
  width: 250px !important;
  height: 42px !important;
  line-height: 42px !important;
}
.ad_content {
  padding: 15px;
  background: #fff;
}
.ad_footer .ad_let {
  position: fixed;
  left: 0;
  bottom: 0;
}
.ad_footer .ad_right {
  position: fixed;
  right: 0;
  bottom: 0;
}
.el-collapse-item__content {
  padding-bottom: 0 !important;
}
.ad_sidebar {
  z-index: 9999;
}
.ad_sidebar .ad_let {
  position: fixed;
  left: 0;
  top: 30%;
}
.ad_sidebar .ad_right {
  position: fixed;
  right: 0;
  top: 30%;
}
.ad_close {
  position: absolute;
  top: 22px;
  right: 5px;
  padding: 5px;
  color: #1b89e6;
}
.ad_Fd{
   position: absolute;
  top: 0px;
  right: 0px;
  padding: 5px;
  color: #1b89e6;
}
.ad_close i {
  font-size: 18px;
}
.el-collapse-item__arrow {
  -webkit-transform: rotateZ(270deg);
  transform: rotateZ(270deg);
}
.ad_footer {
  position: relative;
  z-index: 9998;
}
.ad_content {
  height: 200px;
}
.ad_content img {
  width: 100%;
}
#thediv {
  z-index: 9999;
  position: absolute;
  top: 43px;
  left: 2px;
  height: 120px;
  width: 120px;
}
</style>
